import axios from "axios";

/**
 * LF360-2100 — the organization's settings for AI connectors (MCP). System
 * admins only. Answers `{ mcp: { mcpEnabled, maxPhase, phases, serverUrl } }`.
 */
const ApiSystemSettingMcp = {
  get() {
    return axios.get("api/v1/system-settings/mcp");
  },

  // `changes`: { mcpEnabled?, maxPhase? }; a field left out stays as it is.
  update(changes) {
    return axios.put("api/v1/system-settings/mcp", changes);
  },
};

export default ApiSystemSettingMcp;
